import type { ComponentProps } from 'react';
import { FieldLabel as HeritageFieldLabel } from '@herit-fe/heritage-ui';

/**
 * 폼 라벨 — heritage `FieldLabel` 위에 `required`(빨간 *) 표식을 보강. 필수 입력 라벨에 `required` 부여.
 * heritage FieldLabel 은 asterisk 미지원이라 wrapper 로 추가(외부 npm 패키지라 직접 수정 불가).
 * (cross-app 정합: apps/admin 과 동일 wrapper. web 은 디자인상 표식을 쓰지 않을 수 있음 — `required` 미전달 시
 *  아무것도 렌더하지 않으므로 컴포넌트는 동일하되 시각 차이 없음.)
 */
export function FieldLabel({
  required,
  children,
  ...props
}: ComponentProps<typeof HeritageFieldLabel> & { required?: boolean }) {
  return (
    <HeritageFieldLabel {...props}>
      {children}
      {required && (
        <span className="ml-0.5 text-destructive" aria-hidden="true">
          *
        </span>
      )}
    </HeritageFieldLabel>
  );
}
